import { Button, Play, X } from "@app/ui";
import { useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "../../lib/motion/index.js";
import { useI18n } from "../../lib/useI18n.js";
import { DemoPlayer } from "./DemoPlayer.js";
import type { DemoScriptId } from "./registry.js";

/** "Show me" expander for settings cards: reveals a looping DemoPlayer below
 *  the card's controls. Collapsing unmounts the iframe (frees the instance). */
export function DemoDisclosure({ id }: { id: DemoScriptId }) {
  const { t } = useI18n();
  const reduce = useReducedMotion();
  const [open, setOpen] = useState(false);

  return (
    <div className="mt-3">
      <Button variant="outline" size="sm" onClick={() => setOpen((v) => !v)} aria-expanded={open}>
        {open ? <X className="mr-1.5 h-3.5 w-3.5" /> : <Play className="mr-1.5 h-3.5 w-3.5" />}
        {open ? t("demos.hideDemo") : t("demos.showMe")}
      </Button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            className="overflow-hidden"
            initial={reduce ? false : { height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={reduce ? { opacity: 0 } : { height: 0, opacity: 0 }}
            transition={reduce ? { duration: 0 } : { duration: 0.2 }}
          >
            <DemoPlayer id={id} className="mt-3 max-w-2xl" />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
